<template>
  <div class="payment-page">
    <div class="my-5 p-5 text-center" v-if="bookingDetails.type === 'C'">
      <img src="../assets/images/reservation-success.png" alt="" />
      <h5>{{ $t("listing.bookingRequestSent") }}</h5>
      <div class="my-3 small">
        {{ confirmationMessage }}
      </div>
      <div class="mt-3">
        <button @click="openProperty" class="btn btn-outline-main">
          {{ $t("listing.backToListing") }}
        </button>
      </div>
    </div>
    <div class="my-5 p-5 text-center" v-else>
      <img src="../assets/images/reservation-success.png" alt="" />
      <h5>{{ $t("reservation.bookingSent") }}</h5>
      <div class="my-3 small">
        {{ confirmationMessage }}
      </div>
      <div class="my-4">
        {{ $t("reservation.bookingId") }}: {{ bookingDetails.reservationId }}
      </div>
      <div class="mt-3 mb-2">
        <div>
          {{ $t("reservation.totalPrice") }}: {{ bookingDetails.currency }}
          {{ bookingDetails.total | formatPrice }}
          <span v-if="pricesIncludeVat" class="small"
            >({{ $t("reservation.vatIncluded") }})</span
          >
        </div>
      </div>
      <div class="mt-3">
        <button @click="openProperty" class="btn btn-outline-main">
          {{ $t("listing.backToListing") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { trackMatomoReservationGoal } from "../helpers/matomo";
import { trackPurchaseConfirmation } from "../helpers/analytics";
import { readBookingConfirmation } from "../helpers/bookingConfirmation";

export default {
  name: "ReservationSuccess",
  data() {
    return {
      bookingDetails: {},
      bookerEmail: "",
    };
  },
  methods: {
    ...mapActions("property", ["getPropertySettings"]),
    openProperty() {
      this.$router.push(`/listing/${this.bookingDetails.propertyId}`);
    },
  },
  computed: {
    ...mapState("property", ["settings"]),
    confirmationMessage() {
      return this.bookerEmail
        ? this.$t("reservation.confirmationSent", { email: this.bookerEmail })
        : this.$t("reservation.confirmationSentGeneric");
    },
    pricesIncludeVat() {
      return this.settings?.additionalFeatures?.vatIncluded || false;
    },
  },
  mounted() {
    this.bookingDetails = this.$route.query;
    this.bookerEmail =
      readBookingConfirmation(this.bookingDetails.reservationId)?.email || "";
    if (!this.settings || Object.keys(this.settings).length === 0) {
      this.getPropertySettings(this.bookingDetails.propertyId);
    }
    trackPurchaseConfirmation();
    setTimeout(() => {
      trackMatomoReservationGoal();
    }, 1000);
  },
};
</script>
